const styles = {
  button: {
    margin: '1em 0',
  },
};

export default styles;
